(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-range-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-range-carousel')) {
    customElements.define('product-range-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-range-track]');
        this.prev = this.querySelector('[data-range-prev]');
        this.next = this.querySelector('[data-range-next]');
        this.section = this.closest('.product-range');
        if (!this.track) return;

        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        const update = () => {
          const max = this.track.scrollWidth - this.track.clientWidth;
          this.section?.classList.toggle('is-scrollable', max > 1);
          if (this.prev) this.prev.disabled = this.track.scrollLeft <= 1;
          if (this.next) this.next.disabled = this.track.scrollLeft >= max - 1;
        };

        const step = (direction) => {
          const item = this.track.firstElementChild;
          if (!item) return;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          this.track.scrollBy({
            left: direction * (item.getBoundingClientRect().width + gap),
            behavior: reducedMotion.matches ? 'auto' : 'smooth',
          });
        };

        this.prev?.addEventListener('click', () => step(-1), options);
        this.next?.addEventListener('click', () => step(1), options);
        // A closed row hides the track, so it measures as not scrollable; re-measure as soon as it
        // opens rather than waiting for the ResizeObserver.
        this.querySelector('.product-range__details')?.addEventListener('toggle', update, options);
        this.track.addEventListener('scroll', update, { ...options, passive: true });
        this.observer = new ResizeObserver(update);
        this.observer.observe(this.track);
        update();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
